import { useState, useEffect, useRef } from 'react'

const CARD_WIDTH = 165
const GAP_SIZE = 5
const DEFAULT_DISPLAY_LIMIT = 5
const MIN_DISPLAY_LIMIT = 1
const MAX_DISPLAY_LIMIT = 8

const calculateCardsPerRow = (containerWidth) => {
  if (!containerWidth || containerWidth < CARD_WIDTH) {
    return DEFAULT_DISPLAY_LIMIT
  }
  const cardsPerRow = Math.floor(containerWidth / (CARD_WIDTH + GAP_SIZE))

  return Math.max(MIN_DISPLAY_LIMIT, Math.min(cardsPerRow, MAX_DISPLAY_LIMIT))
}

export const useResponsiveDisplayLimit = (containerWidth) => {
  const [displayLimit, setDisplayLimit] = useState(DEFAULT_DISPLAY_LIMIT)
  const rafRef = useRef(null)

  useEffect(() => {
    if (rafRef.current) {
      cancelAnimationFrame(rafRef.current)
    }

    rafRef.current = requestAnimationFrame(() => {
      const limit = calculateCardsPerRow(containerWidth)
      setDisplayLimit((prev) => (prev !== limit ? limit : prev))
    })

    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current)
      }
    }
  }, [containerWidth])

  return displayLimit
}
